module.exports = __webpack_public_path__ + "img/kg.0346c1a4.svg";